import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// import JS files
import MuiButton from "../shares/MuiButton";
import MuiTextField from "../shares/MuiTextField";
import { toast } from "react-toastify";
import useFetch from "../../context/useFetch";

const NewPassowrd = (props) => {
  const navigate = useNavigate();
  const [postData, setPostData] = useState({});
  const [password, setPassword] = useState();
  const [password1, setPassword1] = useState();
  const { state } = useLocation();

  const changePasswordApi = useFetch({
    method: "post",
    url: `user/change_pass`,
    noHeader: true,
    trigger: false,
    data: postData,
    // caller: props.getFunc,
    argFunc: (res) => {
      if (res.data == "user_not_found") {
        toast.error("کاربر وجود ندارد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else if (res.data == "done") {
        // toast.success(" رمز عبور موردنظر با موفقیت ویرایش شد", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        navigate("/");
        // props.setOpenModal(false);
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = () => {
    if (password == password1) {
      setPostData({
        user: state !== null ? state.phone : undefined,
        password: password,
      });
      changePasswordApi.reFetch();
    } else {
      toast.error("رمز های عبور تطابق ندارند.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  return (
    <>
      <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
        <div className="mx-auto	 w-10/12 sm:w-auto relative py-3 sm:max-w-xl sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-myblue-100 to-myblue-100 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
          <div className="w-11/12 sm:w-auto mx-auto  relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div className="mb-6 back-icon">
                <ArrowForwardIcon onClick={() => navigate(-1)} />
              </div>
              <div className="flex justify-center">
                <h1 className="text-base md:text-2xl font-semibold">
                  تغییر رمز عبور
                </h1>
              </div>
              <div className="mt-3 mb-2">
                <span className="text-xs sm:text-base">
                  رمز عبور جدید خود را وارد نمایید.
                </span>
              </div>
              <div className="divide-y divide-gray-200">
                <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <div className="mt-4">
                    <MuiTextField
                      id="new_password"
                      label="رمزعبور جدید"
                      variant="outlined"
                      size="small"
                      isLTR={true}
                      onChange={(e) => setPassword(e.target.value)}
                      // value={otp !== null ? otp : ""}
                    />
                  </div>
                  <div className="mt-4">
                    <MuiTextField
                      id="new_password"
                      label="تکرار رمزعبور جدید"
                      variant="outlined"
                      size="small"
                      isLTR={true}
                      onChange={(e) => setPassword1(e.target.value)}
                      // value={pass !== null ? otp : ""}
                    />
                  </div>
                  <div>
                    <MuiButton
                      onClick={() => onSubmit()}
                      variant="contained"
                      color="primary"
                      text="تایید"
                      htmlType="submit"
                      // disabled={otp == undefined}
                      isFullWidth={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPassowrd;
